import React from 'react';
import { RootState, useDispatch, useSelector } from 'src/store';
import { setAbnormalColorOverrides } from '../../reducers/BuildRenderRequestSlice';
import { useGetSettingsQuery } from '../../services/chromosomeApi';
import { ColorTable } from '../Common/ColorTable';

export const AbnormalityStains = () => {
  const dispatch = useDispatch();
  const { isLoading, data } = useGetSettingsQuery();
  const { abnormalColorOverrides } = useSelector((state: RootState) => state.buildRenderRequest);
  return (
    <ColorTable
      isLoading={isLoading}
      colors={data?.abnormalityColors || []}
      selectedColors={abnormalColorOverrides}
      colorChanges={(colors) => dispatch(setAbnormalColorOverrides(colors))}
    />
  );
};
